import { render, staticRenderFns } from "./account-description.vue?vue&type=template&id=1c8ffdf5&scoped=true"
import script from "./account-description.vue?vue&type=script&lang=js"
export * from "./account-description.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8ffdf5",
  null
  
)

export default component.exports